import {
  type CallAccessDTO,
  ConsultationRequestApi,
  type GetConsultationRequestShareCodeResponse,
  type ScheduledCallAccessDTO,
  ScheduledConsultationRequestApi
} from '@/generated'
import { globalApiConfig } from '@/services/telehealthApi/APIConfig'

export class CallService {
  static get consultationRequestApi() {
    return new ConsultationRequestApi(globalApiConfig)
  }

  static get scheduledConsultationRequestApi() {
    return new ScheduledConsultationRequestApi(globalApiConfig)
  }

  static async joinCall(consultationRequestId: string): Promise<CallAccessDTO> {
    return (await CallService.consultationRequestApi.joinCall(consultationRequestId)).data
  }

  static async joinWithConsultationShareCode(
    consultationShareCode: string
  ): Promise<CallAccessDTO> {
    return (
      await CallService.consultationRequestApi.joinConsultationRequestWithShareCode(
        consultationShareCode
      )
    ).data
  }

  static async getConsultationShareCode(
    consultationRequestId: string
  ): Promise<GetConsultationRequestShareCodeResponse> {
    return (
      await CallService.consultationRequestApi.getConsultationRequestShareCode(
        consultationRequestId
      )
    ).data
  }

  static async getScheduledConsultationShareCode(
    consultationRequestId: string
  ): Promise<GetConsultationRequestShareCodeResponse> {
    return (
      await CallService.scheduledConsultationRequestApi.getScheduledConsultationRequestShareCode(
        consultationRequestId
      )
    ).data
  }

  static async endCall(consultationRequestId: string): Promise<void> {
    await CallService.consultationRequestApi.endCall(consultationRequestId)
  }

  static async joinScheduledCall(scheduledConsultationId: string): Promise<ScheduledCallAccessDTO> {
    return (
      await CallService.scheduledConsultationRequestApi.joinScheduledCall(scheduledConsultationId)
    ).data
  }

  static async joinScheduledCallWithShareCode(
    scheduledConsultationSharedCode: string
  ): Promise<ScheduledCallAccessDTO> {
    return (
      await CallService.scheduledConsultationRequestApi.joinScheduledConsultationRequestWithShareCode(
        scheduledConsultationSharedCode
      )
    ).data
  }
}
